import { CirclePacking } from '../../models/circlePackingModel';
import { MAIN_DEPTH } from '../constants';

export const color: (circle: CirclePacking, colors: { [key: string]: string } | string) => void = (circle, colors) => {
  if (!colors) {
    return;
  }

  if (typeof colors === 'string') {
    circle.color = colors;
    return;
  }

  circle.color = colors[circle.ancestors[MAIN_DEPTH] ? circle.ancestors[MAIN_DEPTH].label : circle.label];
};
